// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,


  //  c: 'CwdKlL7C97Y=',
  //  k: 'ViJzv2J7Hj/VS5X9E7CmNQ=='

  c: 'KZjOZfp1Qqo=',
  k: '2zTTMiOvolPVS5X9E7CmNQ=='


  //   k: "X0z67Wu1KmPVS5X9E7CmNQ==",
  // c: "Y6N0rDs4Ovw=",
  // tmt
  // c: "zKD5UhyDTPI=",
  // k: "kYRtFC7Rx8I=",


  //mcpsc
  //  c: "EMzt6h8TXkY=",
  //  k: "9d9DiTkBwpbbC2ZMUmlHTQ==",


  //cpscm
  // c: "cYk7f0UoQJs=",
  // k: "lbRROygoHF7deBnOb5BUYw==",


  // //tmmkm
  // c:'PysrqKFHYEc=',
  // k:'8cAR6/Zc1yfVS5X9E7CmNQ=='


};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
